<script setup lang="ts">
    import { defineProps, onMounted, reactive, ref, defineEmits } from "vue";
    import OnboardingUploadInput from "./components/OnboardingUploadInput.vue";

    const props = defineProps({
        user: { type: Object, required: true },
        types_piece_identites: { type: Object, required: true }
    });
    const emit = defineEmits(['saved']);
    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const formData = reactive({
        photo: null as any,
        type_piece_identite: "1",
        numero_piece_identite: '',
        piece_recto: null as any,
        piece_verso: null as any,
    });
    const errors = reactive({
        photo: '',
        piece_recto: '',
        piece_verso: '',
        type_piece_identite: '',
        numero_piece_identite: '',
    });

    function validate() {
        let isValid = true;

        errors.piece_recto = '';
        if (!formData.piece_recto) {
            errors.piece_recto ="La pièce recto est requise";
            isValid = false;
        }

        errors.piece_verso = '';
        if (!formData.piece_verso) {
            errors.piece_verso ="La pièce verso est requise";
            isValid = false;
        }

        errors.type_piece_identite = '';
        if (!formData.type_piece_identite) {
            errors.type_piece_identite ="Le type de pièce d'identité est requis";
            isValid = false;
        }

        errors.numero_piece_identite = '';
        if (!formData.numero_piece_identite) {
            errors.numero_piece_identite ="Le numéro de pièce d'identité est requis";
            isValid = false;
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    function onFileUploaded(field: 'photo' | 'piece_recto' | 'piece_verso', uploadedFile: { file: any, file_name: string, file_preview: string }) {
        formData[field] = { file: uploadedFile.file, name: uploadedFile.file_name, preview: uploadedFile.file_preview };
    }

    async function onSubmit() {
        if (!validate()) { return; }
        emit('saved', formData);
        /**/
    }
</script>

<template>
    <div>
        <h2 class="font-semibold my-0 text-center">{{ props.user.nom + ' ' + props.user.prenom }}</h2>
        <h2 class="font-normal text-center mt-3 mb-7">Identifiez-vous</h2>

        <form class="form">
            <!--Upload file-->
            <onboarding-upload-input id="photo" label="Photo de profil" @uploaded="onFileUploaded('photo', $event)"></onboarding-upload-input>
            <span v-if="!!errors['photo']" class="text-red">{{ errors['photo'] }}</span>

            <div class="h-10"></div>
            <div class="form-field-split active rounded-20 mt-5 my-6">
                <div class="form-field-floating full lg w-40">
                    <select class="form-input-select" name="type_piece_identite" id="type_piece_identite" v-model="formData.type_piece_identite">
                        <option :value="key" v-for="(value, key, index) in props.types_piece_identites" :key="'type_piece_' + index">{{ value }}</option>
                    </select>
                    <label for="type_piece_identite">Pièce d'identité <b class="color-danger">*</b></label>
                </div>
                <hr class="hr" />
                <div class="form-field-floating lg reactive w-60">
                    <input type="text" class="form-input" name="numero_piece_identite" id="numero_piece_identite" v-model="formData.numero_piece_identite" placeholder="">
                    <label for="numero_piece_identite">N° de pièce d'identité <b class="color-danger">*</b></label>
                </div>
            </div>
            <span v-if="!!errors['type_piece_identite']" class="text-red">{{ errors['type_piece_identite'] }}</span>
            <span v-if="!!errors['numero_piece_identite']" class="text-red">{{ errors['numero_piece_identite'] }}</span>

            <onboarding-upload-input id="file-upload-recto" label="Pièce recto" @uploaded="onFileUploaded('piece_recto', $event)" required></onboarding-upload-input>
            <span v-if="!!errors['piece_recto']" class="text-red">{{ errors['piece_recto'] }}</span>

            <onboarding-upload-input id="file-upload-verso" label="Pièce verso" @uploaded="onFileUploaded('piece_verso', $event)" required></onboarding-upload-input>
            <span v-if="!!errors['piece_verso']" class="text-red">{{ errors['piece_verso'] }}</span>

            <span v-if="!!errorMessage" class="text-red">{{ errorMessage }}</span>

            <p class="text-read text-grey-600 text-center mt-6">
                Format de fichier supporté: PDF, JPG, PNG, GIF. Taille max: 5MB.
            </p>

            <button id="btn-save-identity-documents" type="button" class="btn lg w-100 flex-center mt-5" @click="onSubmit">
                <img src="/icons/icon-valider.svg" class="btn-icon" alt="" />
                <span>Valider</span>
            </button>
        </form>
    </div>
</template>
